module.exports = __webpack_public_path__ + "img/pro_two_7.a69c48d7.jpg";